module.exports = {
	"textures": [
		{
			"image": "Track_00_SpriteSheet.png",
			"format": "RGBA8888",
			"size": {
				"w": 2048,
				"h": 2048
			},
			"scale": 1,
			"frames": [
				{
					"filename": "track_background.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 1115,
						"h": 341
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 1115,
						"h": 341
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 1115,
						"h": 341
					}
				},
				{
					"filename": "track_button_00_15.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 266,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 266,
						"h": 106
					},
					"frame": {
						"x": 1118,
						"y": 1,
						"w": 266,
						"h": 106
					}
				},
				{
					"filename": "track_button_00_15_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 266,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 266,
						"h": 106
					},
					"frame": {
						"x": 1386,
						"y": 1,
						"w": 266,
						"h": 106
					}
				},
				{
					"filename": "track_button_00_3.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 265,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 265,
						"h": 110
					},
					"frame": {
						"x": 1654,
						"y": 1,
						"w": 265,
						"h": 110
					}
				},
				{
					"filename": "track_button_00_10_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 126,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 126,
						"h": 108
					},
					"frame": {
						"x": 1921,
						"y": 1,
						"w": 126,
						"h": 108
					}
				},
				{
					"filename": "track_button_00_10_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 126,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 126,
						"h": 107
					},
					"frame": {
						"x": 1921,
						"y": 111,
						"w": 126,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_3_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 265,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 265,
						"h": 110
					},
					"frame": {
						"x": 1118,
						"y": 109,
						"w": 265,
						"h": 110
					}
				},
				{
					"filename": "track_button_00_3_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 265,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 265,
						"h": 110
					},
					"frame": {
						"x": 1385,
						"y": 109,
						"w": 265,
						"h": 110
					}
				},
				{
					"filename": "track_button_00_15_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 265,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 265,
						"h": 106
					},
					"frame": {
						"x": 1652,
						"y": 113,
						"w": 265,
						"h": 106
					}
				},
				{
					"filename": "track_button_00_9_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 128,
						"h": 101
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 128,
						"h": 101
					},
					"frame": {
						"x": 1919,
						"y": 220,
						"w": 128,
						"h": 101
					}
				},
				{
					"filename": "track_button_00_11_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 262,
						"h": 113
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 262,
						"h": 113
					},
					"frame": {
						"x": 1118,
						"y": 221,
						"w": 262,
						"h": 113
					}
				},
				{
					"filename": "track_button_00_8.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 262,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 262,
						"h": 107
					},
					"frame": {
						"x": 1382,
						"y": 221,
						"w": 262,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_8_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 262,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 262,
						"h": 107
					},
					"frame": {
						"x": 1646,
						"y": 221,
						"w": 262,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_13.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 130,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 130,
						"h": 107
					},
					"frame": {
						"x": 1910,
						"y": 323,
						"w": 130,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_8_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 262,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 262,
						"h": 107
					},
					"frame": {
						"x": 1382,
						"y": 330,
						"w": 262,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_12.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 260,
						"h": 111
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 260,
						"h": 111
					},
					"frame": {
						"x": 1118,
						"y": 336,
						"w": 260,
						"h": 111
					}
				},
				{
					"filename": "track_button_00_12_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 260,
						"h": 111
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 260,
						"h": 111
					},
					"frame": {
						"x": 1646,
						"y": 330,
						"w": 260,
						"h": 111
					}
				},
				{
					"filename": "track_button_00_12_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 260,
						"h": 111
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 260,
						"h": 111
					},
					"frame": {
						"x": 1380,
						"y": 439,
						"w": 260,
						"h": 111
					}
				},
				{
					"filename": "track_button_00_13_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 130,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 130,
						"h": 107
					},
					"frame": {
						"x": 1908,
						"y": 432,
						"w": 130,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_4_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 259,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 259,
						"h": 106
					},
					"frame": {
						"x": 1642,
						"y": 443,
						"w": 259,
						"h": 106
					}
				},
				{
					"filename": "track_button_00_13_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 130,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 130,
						"h": 107
					},
					"frame": {
						"x": 1903,
						"y": 541,
						"w": 130,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_7.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 259,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 259,
						"h": 105
					},
					"frame": {
						"x": 1642,
						"y": 551,
						"w": 259,
						"h": 105
					}
				},
				{
					"filename": "track_button_00_9.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 102
					},
					"frame": {
						"x": 1903,
						"y": 650,
						"w": 129,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_7_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 259,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 259,
						"h": 105
					},
					"frame": {
						"x": 1,
						"y": 344,
						"w": 259,
						"h": 105
					}
				},
				{
					"filename": "track_button_00_7_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 259,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 259,
						"h": 105
					},
					"frame": {
						"x": 262,
						"y": 344,
						"w": 259,
						"h": 105
					}
				},
				{
					"filename": "track_button_00_11.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 258,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 258,
						"h": 107
					},
					"frame": {
						"x": 523,
						"y": 344,
						"w": 258,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_4.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 258,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 258,
						"h": 106
					},
					"frame": {
						"x": 783,
						"y": 344,
						"w": 258,
						"h": 106
					}
				},
				{
					"filename": "track_button_00_0.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 72,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 72,
						"h": 102
					},
					"frame": {
						"x": 1043,
						"y": 344,
						"w": 72,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_0_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 72,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 72,
						"h": 102
					},
					"frame": {
						"x": 1043,
						"y": 448,
						"w": 72,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_4_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 258,
						"h": 106
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 258,
						"h": 106
					},
					"frame": {
						"x": 783,
						"y": 452,
						"w": 258,
						"h": 106
					}
				},
				{
					"filename": "track_button_00_16.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 258,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 258,
						"h": 102
					},
					"frame": {
						"x": 1117,
						"y": 449,
						"w": 258,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_0_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 72,
						"h": 101
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 72,
						"h": 101
					},
					"frame": {
						"x": 1043,
						"y": 552,
						"w": 72,
						"h": 101
					}
				},
				{
					"filename": "track_button_00_16_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 258,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 258,
						"h": 102
					},
					"frame": {
						"x": 1377,
						"y": 552,
						"w": 258,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_16_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 258,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 258,
						"h": 102
					},
					"frame": {
						"x": 1117,
						"y": 553,
						"w": 258,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_11_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 257,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 257,
						"h": 107
					},
					"frame": {
						"x": 1377,
						"y": 656,
						"w": 257,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_34.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 244,
						"h": 96
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 244,
						"h": 96
					},
					"frame": {
						"x": 1636,
						"y": 658,
						"w": 244,
						"h": 96
					}
				},
				{
					"filename": "track_button_00_9_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 129,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 129,
						"h": 102
					},
					"frame": {
						"x": 1882,
						"y": 754,
						"w": 129,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_34_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 244,
						"h": 96
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 244,
						"h": 96
					},
					"frame": {
						"x": 1636,
						"y": 756,
						"w": 244,
						"h": 96
					}
				},
				{
					"filename": "track_button_00_34_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 244,
						"h": 96
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 244,
						"h": 96
					},
					"frame": {
						"x": 1,
						"y": 451,
						"w": 244,
						"h": 96
					}
				},
				{
					"filename": "track_button_00_19.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 242,
						"h": 96
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 242,
						"h": 96
					},
					"frame": {
						"x": 247,
						"y": 451,
						"w": 242,
						"h": 96
					}
				},
				{
					"filename": "track_button_00_19_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 242,
						"h": 96
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 242,
						"h": 96
					},
					"frame": {
						"x": 491,
						"y": 453,
						"w": 242,
						"h": 96
					}
				},
				{
					"filename": "track_button_00_19_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 242,
						"h": 96
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 242,
						"h": 96
					},
					"frame": {
						"x": 1,
						"y": 549,
						"w": 242,
						"h": 96
					}
				},
				{
					"filename": "track_button_00_20.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 242,
						"h": 94
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 242,
						"h": 94
					},
					"frame": {
						"x": 245,
						"y": 549,
						"w": 242,
						"h": 94
					}
				},
				{
					"filename": "track_button_00_20_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 242,
						"h": 94
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 242,
						"h": 94
					},
					"frame": {
						"x": 489,
						"y": 551,
						"w": 242,
						"h": 94
					}
				},
				{
					"filename": "track_button_00_20_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 242,
						"h": 94
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 242,
						"h": 94
					},
					"frame": {
						"x": 245,
						"y": 645,
						"w": 242,
						"h": 94
					}
				},
				{
					"filename": "track_button_00_33.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 238,
						"h": 95
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 238,
						"h": 95
					},
					"frame": {
						"x": 1,
						"y": 647,
						"w": 238,
						"h": 95
					}
				},
				{
					"filename": "track_button_00_33_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 238,
						"h": 95
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 238,
						"h": 95
					},
					"frame": {
						"x": 733,
						"y": 560,
						"w": 238,
						"h": 95
					}
				},
				{
					"filename": "track_button_00_33_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 238,
						"h": 95
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 238,
						"h": 95
					},
					"frame": {
						"x": 489,
						"y": 647,
						"w": 238,
						"h": 95
					}
				},
				{
					"filename": "track_button_00_24.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 233,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 233,
						"h": 107
					},
					"frame": {
						"x": 241,
						"y": 741,
						"w": 233,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_24_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 233,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 233,
						"h": 107
					},
					"frame": {
						"x": 1,
						"y": 744,
						"w": 233,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_10.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 127,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 127,
						"h": 108
					},
					"frame": {
						"x": 973,
						"y": 655,
						"w": 127,
						"h": 108
					}
				},
				{
					"filename": "track_button_00_24_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 233,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 233,
						"h": 107
					},
					"frame": {
						"x": 729,
						"y": 657,
						"w": 233,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_29.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 229,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 229,
						"h": 108
					},
					"frame": {
						"x": 476,
						"y": 744,
						"w": 229,
						"h": 108
					}
				},
				{
					"filename": "track_button_00_29_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 229,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 229,
						"h": 108
					},
					"frame": {
						"x": 236,
						"y": 850,
						"w": 229,
						"h": 108
					}
				},
				{
					"filename": "track_button_00_30_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 229,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 229,
						"h": 103
					},
					"frame": {
						"x": 1,
						"y": 853,
						"w": 229,
						"h": 103
					}
				},
				{
					"filename": "track_button_00_30_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 229,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 229,
						"h": 102
					},
					"frame": {
						"x": 1,
						"y": 958,
						"w": 229,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_30.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 229,
						"h": 101
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 229,
						"h": 101
					},
					"frame": {
						"x": 1102,
						"y": 657,
						"w": 229,
						"h": 101
					}
				},
				{
					"filename": "track_button_00_29_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 228,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 228,
						"h": 108
					},
					"frame": {
						"x": 1102,
						"y": 760,
						"w": 228,
						"h": 108
					}
				},
				{
					"filename": "track_button_00_14.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 127,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 127,
						"h": 102
					},
					"frame": {
						"x": 964,
						"y": 765,
						"w": 127,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_23_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 228,
						"h": 104
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 228,
						"h": 104
					},
					"frame": {
						"x": 707,
						"y": 766,
						"w": 228,
						"h": 104
					}
				},
				{
					"filename": "track_button_00_23_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 228,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 228,
						"h": 103
					},
					"frame": {
						"x": 467,
						"y": 854,
						"w": 228,
						"h": 103
					}
				},
				{
					"filename": "track_button_00_14_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 127,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 127,
						"h": 102
					},
					"frame": {
						"x": 937,
						"y": 869,
						"w": 127,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_23.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 227,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 227,
						"h": 102
					},
					"frame": {
						"x": 697,
						"y": 872,
						"w": 227,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_22.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 216,
						"h": 83
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 216,
						"h": 83
					},
					"frame": {
						"x": 467,
						"y": 959,
						"w": 216,
						"h": 83
					}
				},
				{
					"filename": "track_button_00_22_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 216,
						"h": 83
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 216,
						"h": 83
					},
					"frame": {
						"x": 232,
						"y": 960,
						"w": 216,
						"h": 83
					}
				},
				{
					"filename": "track_button_00_22_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 216,
						"h": 83
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 216,
						"h": 83
					},
					"frame": {
						"x": 1332,
						"y": 765,
						"w": 216,
						"h": 83
					}
				},
				{
					"filename": "track_button_00_37_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 79,
						"h": 112
					},
					"spriteSourceSize": {
						"x": 923,
						"y": 838,
						"w": 79,
						"h": 112
					},
					"frame": {
						"x": 1550,
						"y": 765,
						"w": 79,
						"h": 112
					}
				},
				{
					"filename": "track_button_00_31.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 82
					},
					"frame": {
						"x": 1332,
						"y": 850,
						"w": 215,
						"h": 82
					}
				},
				{
					"filename": "track_button_00_31_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 82
					},
					"frame": {
						"x": 1631,
						"y": 854,
						"w": 215,
						"h": 82
					}
				},
				{
					"filename": "track_button_00_37.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 77,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 925,
						"y": 838,
						"w": 77,
						"h": 110
					},
					"frame": {
						"x": 1549,
						"y": 879,
						"w": 77,
						"h": 110
					}
				},
				{
					"filename": "track_button_00_5.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 188,
						"h": 69
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 188,
						"h": 69
					},
					"frame": {
						"x": 1848,
						"y": 858,
						"w": 188,
						"h": 69
					}
				},
				{
					"filename": "track_button_00_5_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 188,
						"h": 69
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 188,
						"h": 69
					},
					"frame": {
						"x": 1848,
						"y": 929,
						"w": 188,
						"h": 69
					}
				},
				{
					"filename": "track_button_00_32.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 81
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 81
					},
					"frame": {
						"x": 1628,
						"y": 938,
						"w": 215,
						"h": 81
					}
				},
				{
					"filename": "track_button_00_5_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 188,
						"h": 69
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 188,
						"h": 69
					},
					"frame": {
						"x": 1845,
						"y": 1000,
						"w": 188,
						"h": 69
					}
				},
				{
					"filename": "track_button_00_32_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 81
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 81
					},
					"frame": {
						"x": 1066,
						"y": 870,
						"w": 215,
						"h": 81
					}
				},
				{
					"filename": "track_button_00_32_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 215,
						"h": 81
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 215,
						"h": 81
					},
					"frame": {
						"x": 1283,
						"y": 934,
						"w": 215,
						"h": 81
					}
				},
				{
					"filename": "track_button_00_31_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 214,
						"h": 82
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 214,
						"h": 82
					},
					"frame": {
						"x": 1066,
						"y": 953,
						"w": 214,
						"h": 82
					}
				},
				{
					"filename": "track_button_00_14_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 127,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 127,
						"h": 102
					},
					"frame": {
						"x": 926,
						"y": 973,
						"w": 127,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_21.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 210,
						"h": 81
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 210,
						"h": 81
					},
					"frame": {
						"x": 685,
						"y": 976,
						"w": 210,
						"h": 81
					}
				},
				{
					"filename": "track_button_00_21_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 210,
						"h": 81
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 210,
						"h": 81
					},
					"frame": {
						"x": 450,
						"y": 1044,
						"w": 210,
						"h": 81
					}
				},
				{
					"filename": "track_button_00_21_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 210,
						"h": 81
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 210,
						"h": 81
					},
					"frame": {
						"x": 232,
						"y": 1045,
						"w": 210,
						"h": 81
					}
				},
				{
					"filename": "track_button_00_1.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 93,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 93,
						"h": 107
					},
					"frame": {
						"x": 1500,
						"y": 991,
						"w": 93,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_17.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 187,
						"h": 69
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 187,
						"h": 69
					},
					"frame": {
						"x": 1282,
						"y": 1017,
						"w": 187,
						"h": 69
					}
				},
				{
					"filename": "track_button_00_17_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 187,
						"h": 69
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 187,
						"h": 69
					},
					"frame": {
						"x": 1055,
						"y": 1037,
						"w": 187,
						"h": 69
					}
				},
				{
					"filename": "track_button_00_17_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 187,
						"h": 68
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 187,
						"h": 68
					},
					"frame": {
						"x": 1,
						"y": 1062,
						"w": 187,
						"h": 68
					}
				},
				{
					"filename": "track_button_00_18.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 186,
						"h": 70
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 186,
						"h": 70
					},
					"frame": {
						"x": 1595,
						"y": 1021,
						"w": 186,
						"h": 70
					}
				},
				{
					"filename": "track_button_00_18_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 186,
						"h": 70
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 186,
						"h": 70
					},
					"frame": {
						"x": 1244,
						"y": 1088,
						"w": 186,
						"h": 70
					}
				},
				{
					"filename": "track_button_00_18_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 186,
						"h": 70
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 186,
						"h": 70
					},
					"frame": {
						"x": 662,
						"y": 1059,
						"w": 186,
						"h": 70
					}
				},
				{
					"filename": "track_button_00_6.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 69
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 69
					},
					"frame": {
						"x": 850,
						"y": 1077,
						"w": 183,
						"h": 69
					}
				},
				{
					"filename": "track_button_00_6_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 69
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 69
					},
					"frame": {
						"x": 1035,
						"y": 1108,
						"w": 183,
						"h": 69
					}
				},
				{
					"filename": "track_button_00_6_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 183,
						"h": 68
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 183,
						"h": 68
					},
					"frame": {
						"x": 444,
						"y": 1127,
						"w": 183,
						"h": 68
					}
				},
				{
					"filename": "track_button_00_36_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 175,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 175,
						"h": 107
					},
					"frame": {
						"x": 629,
						"y": 1131,
						"w": 175,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_36.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 174,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 174,
						"h": 107
					},
					"frame": {
						"x": 806,
						"y": 1148,
						"w": 174,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_36_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 174,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 174,
						"h": 107
					},
					"frame": {
						"x": 190,
						"y": 1128,
						"w": 174,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_35_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 174,
						"h": 104
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 174,
						"h": 104
					},
					"frame": {
						"x": 1,
						"y": 1132,
						"w": 174,
						"h": 104
					}
				},
				{
					"filename": "track_button_00_25.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 173,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 173,
						"h": 108
					},
					"frame": {
						"x": 366,
						"y": 1197,
						"w": 173,
						"h": 108
					}
				},
				{
					"filename": "track_button_00_37_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 77,
						"h": 110
					},
					"spriteSourceSize": {
						"x": 925,
						"y": 838,
						"w": 77,
						"h": 110
					},
					"frame": {
						"x": 541,
						"y": 1197,
						"w": 77,
						"h": 110
					}
				},
				{
					"filename": "track_button_00_25_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 173,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 173,
						"h": 108
					},
					"frame": {
						"x": 620,
						"y": 1240,
						"w": 173,
						"h": 108
					}
				},
				{
					"filename": "track_button_00_25_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 173,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 173,
						"h": 108
					},
					"frame": {
						"x": 177,
						"y": 1237,
						"w": 173,
						"h": 108
					}
				},
				{
					"filename": "track_button_00_26_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 173,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 173,
						"h": 103
					},
					"frame": {
						"x": 1,
						"y": 1238,
						"w": 173,
						"h": 103
					}
				},
				{
					"filename": "track_button_00_35_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 173,
						"h": 103
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 173,
						"h": 103
					},
					"frame": {
						"x": 1,
						"y": 1343,
						"w": 173,
						"h": 103
					}
				},
				{
					"filename": "track_button_00_26_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 173,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 173,
						"h": 102
					},
					"frame": {
						"x": 352,
						"y": 1307,
						"w": 173,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_26.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 173,
						"h": 101
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 173,
						"h": 101
					},
					"frame": {
						"x": 176,
						"y": 1347,
						"w": 173,
						"h": 101
					}
				},
				{
					"filename": "track_button_00_35.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 172,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 172,
						"h": 102
					},
					"frame": {
						"x": 1,
						"y": 1448,
						"w": 172,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_27.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 108
					},
					"frame": {
						"x": 527,
						"y": 1309,
						"w": 90,
						"h": 108
					}
				},
				{
					"filename": "track_button_00_1_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 93,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 93,
						"h": 107
					},
					"frame": {
						"x": 351,
						"y": 1411,
						"w": 93,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_1_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 93,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 93,
						"h": 107
					},
					"frame": {
						"x": 175,
						"y": 1450,
						"w": 93,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_28_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 93,
						"h": 105
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 93,
						"h": 105
					},
					"frame": {
						"x": 1,
						"y": 1552,
						"w": 93,
						"h": 105
					}
				},
				{
					"filename": "track_button_00_28_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 93,
						"h": 104
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 93,
						"h": 104
					},
					"frame": {
						"x": 1783,
						"y": 1071,
						"w": 93,
						"h": 104
					}
				},
				{
					"filename": "track_button_00_28.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 93,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 93,
						"h": 102
					},
					"frame": {
						"x": 1878,
						"y": 1071,
						"w": 93,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_27_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 108
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 108
					},
					"frame": {
						"x": 1878,
						"y": 1175,
						"w": 90,
						"h": 108
					}
				},
				{
					"filename": "track_button_00_27_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 107
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 107
					},
					"frame": {
						"x": 1595,
						"y": 1093,
						"w": 90,
						"h": 107
					}
				},
				{
					"filename": "track_button_00_2.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 102
					},
					"frame": {
						"x": 1687,
						"y": 1093,
						"w": 90,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_2_hover.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 102
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 102
					},
					"frame": {
						"x": 1779,
						"y": 1177,
						"w": 90,
						"h": 102
					}
				},
				{
					"filename": "track_button_00_2_win.png",
					"rotated": false,
					"trimmed": false,
					"sourceSize": {
						"w": 90,
						"h": 101
					},
					"spriteSourceSize": {
						"x": 0,
						"y": 0,
						"w": 90,
						"h": 101
					},
					"frame": {
						"x": 1687,
						"y": 1197,
						"w": 90,
						"h": 101
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:35fade2eb353e018b549f52bbf3949c9:be171daa3865d189a29c3b1a761002d6:b61d93aee9fcfe3e040476f507a73134$"
	}
};